/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yes_Import_SettingsInputs */



/**
* | output |
* | --- |
* | "Yes, Import Settings" |
*
* @param {Yes_Import_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const yes_import_settings = /** @type {((inputs?: Yes_Import_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yes_Import_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Oui, importer les paramètres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ja, Importeinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sì, importa impostazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Да, импорт настроек.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sí, importar configuraciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("是的，导入设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("はい、設定をインポートします")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हां, सेटिंग्स आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sim, importar configurações")
	return /** @type {LocalizedString} */ ("Yes, Import Settings")
});